<template>
  <div class="property_wrap">
    <div class="pro_top">标题栏设置</div>
    <div class="pro_con">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="文字说明设置:">
          <el-input v-model="form.name" maxlength="20" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {}
    };
  }
};
</script>

 